import {
  getSettings,
  getColorTheme,
  getCustomThemePalette,
  getTextScale,
  getVoicePrefs,
  getHomeChatState,
  getHasSeenWebAccessOffer,
  getWebAccessLinkOfferNeverAsk,
} from './storage';
import { saveCloudUserPreferences } from './cloudApi';

let syncTimer = null;
let inFlight = false;

const buildPreferencePayload = () => ({
  settings: getSettings() || {},
  colorTheme: getColorTheme(),
  customThemePalette: getCustomThemePalette(),
  textScale: getTextScale(),
  voicePrefs: getVoicePrefs(),
  homeChatState: getHomeChatState(),
  hasSeenWebAccessOffer: getHasSeenWebAccessOffer(),
  webAccessLinkNeverAsk: getWebAccessLinkOfferNeverAsk(),
});

const runSync = async () => {
  if (inFlight) return;
  inFlight = true;
  try {
    const { getCurrentFirebaseIdToken } = await import('./firebase');
    const token = await getCurrentFirebaseIdToken();
    if (!token) return;
    await saveCloudUserPreferences(buildPreferencePayload());
  } catch (e) {
    const msg = e && typeof e === 'object' && 'message' in e ? e.message : String(e);
    console.warn('[userPrefsCloudSync] sync failed', msg || e);
  } finally {
    inFlight = false;
  }
};

export const queueUserPrefsCloudSync = (delayMs = 500) => {
  if (syncTimer) clearTimeout(syncTimer);
  syncTimer = setTimeout(() => {
    syncTimer = null;
    void runSync();
  }, Math.max(50, Number(delayMs) || 500));
};
